import { Label } from '@/components/ui/Label';

import { DateTimePicker } from './DateTimePicker';

interface DateTimeInputProps {
    label: string;
    value?: Date;
    onChange: (value?: Date) => void;
    onCommit?: () => void;
    minValue?: Date;
    maxValue?: Date;
}

export function DateTimeInput({
    label,
    value,
    onChange,
    onCommit,
    minValue,
    maxValue,
}: DateTimeInputProps) {
    return (
        <div className="flex items-center justify-between gap-2">
            <Label className="text-grey-200">{label}</Label>
            <DateTimePicker
                className="min-w-[176px] shrink-0"
                label={label}
                value={value}
                onChange={onChange}
                onCommit={onCommit}
                minValue={minValue}
                maxValue={maxValue}
            />
        </div>
    );
}
